export interface CombatState {
  stamina: number;
  momentum: number;
  overdriveUntil: number;
}

export function createCombatState(): CombatState {
  return { stamina: 100, momentum: 0, overdriveUntil: 0 };
}

export function applyAttack(state: CombatState, kind: "light" | "heavy" | "dodge", nowMs = performance.now()): CombatState {
  const cost = kind === "light" ? 10 : kind === "heavy" ? 40 : 20;
  const momentumGain = kind === "light" ? 8 : kind === "heavy" ? 16 : 0;
  const stamina = state.overdriveUntil > nowMs ? state.stamina : Math.max(0, state.stamina - cost);
  const momentum = Math.min(100, state.momentum + momentumGain);
  return {
    stamina,
    momentum,
    overdriveUntil: momentum >= 100 ? nowMs + 10000 : state.overdriveUntil
  };
}

export function takeDamage(state: CombatState): CombatState {
  return { ...state, momentum: 0 };
}
